
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-products",
      function () {
        return require("private-next-pages/special-products/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special-products"])
      });
    }
  